<template>
  <div class="container">
        <div class="title">
            <router-link :to="{path:'/'}"><img :src="url+'/img/zhibo/sy.png'" class="return" /></router-link>
            <img :src="url+'/img/zhibo/fh.png'" class="return" @click="clickReturn" />
            <img :src="url+'/img/zhibo/gx.png'" class="guang1" />
            <img :src="url+'/img/zhibo/gx.png'" class="guang2" />
        </div>
      <div class="content">
        <!-- 左侧 -->
        <div class="left animate__animated animate__slideInLeft">
          <img :src="url+'/img/zhibo/ybfc.png'" class="bg" />
          <div class="leftBox flexColumn">
            <!-- 左一 -->
            <div class="leftBox1 flexColumn">
              <div class="subTit">各类产品销量占比</div>
              <div class="leftContent leftContent1">
                <div class="leftContent1A">
                  <div class="leftContent1Item" v-for="(item,index) in leftData1" :key="index">
                    <leftPie :rate="item.percent" :title="item.name" />
                  </div>
                </div>
                <router-link :to="{path:'/xiaofeiChanpin'}"><div class="more1">更多></div></router-link>
                <div class="leftContent1B flexColumn">
                  <div class="leftContent1BTit"><div class="leftContent1BItem" :class="{leftContent1BItemCur:leftTitCurIndex==index}" v-for="(item,index) in leftTit" :key="index" @click="left2Tab(index,1)"><span>{{item}}</span></div></div>
                  <div class="leftContent1BContent"><leftBar :datas="leftData2[leftTitCurIndex]"  v-if="left2Show"/></div>
                </div>
              </div>
            </div>
            <!-- 左二 -->
            <div class="leftBox2 flexColumn">
              <div class="subTit">订单列表</div>
              <div class="leftContent2 flexColumn">
                <div class="leftContent1BTit"><div class="leftContent1BItem" :class="{leftContent1BItemCur:leftTitCurIndex1==index}" v-for="(item,index) in leftTit" :key="index" @click="left2Tab(index,2)"><span>{{item}}</span></div></div>
                <div class="leftContent2Tit"><span>订单</span><img :src="url+'/img/zhibo/jbjx.png'" /></div>
                <div class="leftContent2Box flexColumn">
                  <div class="tabTr"><span v-for="(item,index) in leftData3Tit" :key="index">{{item}}</span></div>
                    <txtScroll class="leftContent2Info"   v-if="left2Show1">
                      <div v-for="(item,index) in leftData3" :key="index" class="scroll_item">
                        <span>{{index+1}}</span><span>{{item.name}}</span><span>{{item.price}}</span><span>{{item.order}}</span>
                      </div>  
                    </txtScroll>
                </div>
              </div>
            </div>
            <!-- 左三 -->
            <div class="leftBox3">
              <div class="subTit">各类产品下单统计</div>
              <div class="leftContent leftContent3"><leftBar1 /></div>
            </div>
          </div>
        </div>
         <!--中间地图  -->
        <div class="center">
          <!-- <div class="subTit"></div> -->
          <div class="centerBox flexColumn">
            <div class="center1">
              <div class="numBox">当前直播在线人数：<countTo :startVal="startVal" :endVal="endVal" :duration="1000" class="fontNum"></countTo>人</div> 
            </div>
            <img :src="url+'/img/zhibo/jt.png'" class="center2" />
            <div class="center3">
              <div class="videoBox" id="video"><vue3VideoPlay loop  color="#ff0000" width="100%" height="100%" title="冰河世纪" :src="options.src" :type="options.type" :autoPlay="true"  @play="onPlay" /></div>
            </div>
            <div class="center4 flexColumn">
              <h3>GMV趋势</h3>
              <div class="centerContent4"><centerLine /></div>
            </div>
          </div>
        </div>
        
        <!-- 右侧 -->
        <div class="right animate__animated animate__slideInRight">
          <img :src="url+'/img/zhibo/ybfc.png'" class="bg" />
          <div class="rightBox flexColumn">
            <!-- 右一 -->
            <div class="rightBox1 flexColumn">
              <div class="subTit">销售分析</div>
              <router-link :to="{path:'/xiaofeiData'}"><div class="more">更多></div></router-link>
              <div class="leftContent1BTit"><div class="leftContent1BItem" :class="{leftContent1BItemCur:leftTitCurIndex2==index}" v-for="(item,index) in leftTit" :key="index" @click="left2Tab(index,3)"><span>{{item}}</span></div></div>
              <div class="rightContent1"><rightBar1 :datas="rightData1[leftTitCurIndex2]" v-if="left2Show2"/></div>
              <!-- <leftBar :datas="leftData2[leftTitCurIndex]"  v-if="left2Show"/> -->
            </div>
            <!-- 右二 -->
            <div class="rightBox2 flexColumn">
              <div class="rightTit"><span>直播间留言</span><img :src="url+'/img/zhibo/jbjx.png'"/></div>
              <txtScroll class="rightContent2"  >
                <div v-for="(item,index) in rightData2" :key="index" class="scroll_item">
                  <span>{{index+1}}</span><span>{{item.content}}</span><span>{{item.user}}</span>
                </div>  
              </txtScroll>
            </div>
            <!-- 右三 -->
            <div class="rightBox3 flexColumn">
              <div class="subTit">直播间商品销量排行</div>
              <div class="rightContent3 flexColumn">
                <div class="leftContent1BTit"><div class="leftContent1BItem" :class="{leftContent1BItemCur:leftTitCurIndex2==index}" v-for="(item,index) in leftTit" :key="index" @click="left2Tab(index,4)"><span>{{item}}</span></div></div>
                <div class="rightEchart3"><rightBar2 :datas="rightData3[leftTitCurIndex3]" v-if="left2Show3" /></div>
              </div>
            </div>
            <!-- 右四 -->
            <div class="subTit">直播间投诉与建议</div>
            <div class="rightBox2 rightBox4 flexColumn">
              <div class="rightTit"><span>投诉与建议</span><img :src="url+'/img/zhibo/jbjx.png'"/></div>
              <txtScroll class="rightContent2 rightContent4"  >
                <div v-for="(item,index) in rightData4" :key="index" class="scroll_item">
                  <span>{{index+1}}</span><span>{{item.content}}</span><span>{{item.user}}</span>
                </div>  
              </txtScroll>
            </div>
          </div>
        </div>
      </div>
       <footer1 />
  </div>
  
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from 'vue-router'

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// import waterimg from "@/assets/img/xaiofei/fk.png"

import countTo from"@/components/vue-count-to/src/vue-countTo.vue"
import leftPie from "../components/zhibo/leftPie"
import leftBar from "../components/zhibo/leftBar"
import txtScroll from "../components/xiaofeiChanpin/txtScroll.vue"
import leftBar1 from "../components/zhibo/leftBar1"
import rightBar1 from "../components/zhibo/rightBar1"
import rightBar2 from "../components/zhibo/rightBar2"
import centerLine from "../components/zhibo/centerLine"
import footer1 from "../components/footer.vue";



export default {
  name: "Home",
  setup() {
    const { proxy } = getCurrentInstance();
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      url:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      currentTime: "",
      leftData1:[{name:"A产品",percent:"70%"},{name:"B产品",percent:"60%"},{name:"C产品",percent:"98%"}],
      leftData2:[
        [{ name: "A产品", percent: "58", total: "158111", finished: "82311" },
        { name: "B产品", percent: "76", total: "16522", finished: "9873"  },
        { name: "C产品", percent: "98", total: "5823", finished: "5500"  },],
        [{ name: "A产品", percent: "58", total: "15811", finished: "2311" },
        { name: "B产品", percent: "76", total: "122", finished: "873"  },
        { name: "C产品", percent: "98", total: "583", finished: "5500"  },],
        [{ name: "A产品", percent: "58", total: "15111", finished: "82311" },
        { name: "B产品", percent: "76", total: "1622", finished: "9873"  },
        { name: "C产品", percent: "98", total: "823", finished: "5500"  },]
        
      ],
      leftTit:["月度","季度","年度"],
      leftTitCurIndex:0,
      leftTitCurIndex1:0,
      leftTitCurIndex2:0,
      leftTitCurIndex3:0,
      left2Show:true,
      left2Show1:true,
      left2Show2:true,
      left2Show3:true,
      leftData3Tit:["编号","商品","GMV","订单数目"],
      leftData3:[
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
        {name: 'XXX产品',price:"100",order:458,unit:"吨"},
    ],
    endVal:8888,
    options:{
        src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/zhibo.mp4", //视频源
        type: 'video/mp4', //视频类型
      },
     rightData1:[
        [{ name: "销售额", percent: "58", total: "158111", finished: "82311" },
        { name: "退单量", percent: "76", total: "16522", finished: "9873"  }],
        [{ name: "销售额", percent: "58", total: "15811", finished: "2311" },
        { name: "退单量", percent: "76", total: "122", finished: "873"  },],
        [{ name: "销售额", percent: "58", total: "15111", finished: "82311" },
        { name: "退单量", percent: "76", total: "1622", finished: "9873"  }]
        
      ],
      rightData2:[
        {content: '助力乡村振兴 大力发展电商直播平台',user:"用户1"},
        {content: '助力乡村振兴 大力发展电商直播平台',user:"用户1"},
        {content: '助力乡村振兴 大力发展电商直播平台',user:"用户1"},
        {content: '助力乡村振兴 大力发展电商直播平台',user:"用户1"},
        {content: '助力乡村振兴 大力发展电商直播平台',user:"用户1"},
        {content: '助力乡村振兴 大力发展电商直播平台',user:"用户1"},
        {content: '助力乡村振兴 大力发展电商直播平台',user:"用户1"},
        {content: '助力乡村振兴 大力发展电商直播平台',user:"用户1"},
    ],
    rightData3:[[
        {value: 335,name: '产品A' },
        { value: 1335, name: '产品B'},
        {value: 235,name: '产品C'},
        { value: 635,name: '产品D'},
        {value: 335,name: '产品E'},
        {value: 1335,name: '产品F'},
        {value: 235,name: '产品G'},
        {value: 635,name: '产品H'},
        ],[
          {value: 1335,name: '产品A' },
        { value: 335, name: '产品B'},
        {value: 635,name: '产品C'},
        { value: 835,name: '产品D'},
        {value: 1335,name: '产品E'},
        {value: 867,name: '产品F'},
        {value: 1035,name: '产品G'},
        {value: 635,name: '产品H'},
        ],[
          {value: 1335,name: '产品A' },
        { value: 1035, name: '产品B'},
        {value: 535,name: '产品C'},
        { value: 896,name: '产品D'},
        {value: 456,name: '产品E'},
        {value: 789,name: '产品F'},
        {value: 653,name: '产品G'},
        {value: 1125,name: '产品H'},
        ]
        
      ],
    rightData4:[
        {content: '收到货包装有破损...',user:"用户1"},
        {content: '退款无法点击...',user:"用户1"},
        {content: '收到货包装有破损...',user:"用户1"},
        {content: '收到货包装有破损...',user:"用户1"},
        {content: '收到货包装有破损...',user:"用户1"},
        {content: '收到货包装有破损...',user:"用户1"},
        {content: '收到货包装有破损...',user:"用户1"},
        {content: '收到货包装有破损...',user:"用户1"},
    ],
    });
    onMounted(() => {
        // setInterval(()=>{
        //   state.endVal = 87662
        // },5000)
    })
    onUnmounted(() => {
      // 清理资源
      
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    })
    // 返回上一页
    function clickReturn(){
      router.go(-1);
    }
    // 左側切換
    function left2Tab(index,index1){
      console.log(index1)
      // 左一--销量占比
      if(index1==1){
        this.left2Show = false; // 点击后先隐藏div
        state.leftTitCurIndex = index
        setTimeout(() => {
          this.left2Show = true; // 200ms后再重新显示div（模拟刷新）
        }, 200);
      }else if(index1==2){
        // 左二--订单列表
        this.left2Show1 = false; // 点击后先隐藏div
        state.leftTitCurIndex1 = index
        setTimeout(() => {
          this.left2Show1 = true; // 200ms后再重新显示div（模拟刷新）
        }, 200);
      }else if(index1==3){
        // 右一--销售分析
        this.left2Show2 = false; // 点击后先隐藏div
        state.leftTitCurIndex2 = index
        setTimeout(() => {
          this.left2Show2 = true; // 200ms后再重新显示div（模拟刷新）
        }, 200);
      }else{
        // 右二--直播间销量排行
        this.left2Show3 = false; // 点击后先隐藏div
        state.leftTitCurIndex3 = index
        setTimeout(() => {
          this.left2Show3 = true; // 200ms后再重新显示div（模拟刷新）
        }, 200);
      }
      
    }
    // left2Tab2
    return {
      ...toRefs(state),
      clickReturn,
      left2Tab,
      
    };
  },
  components: {
      leftPie,
      leftBar,
      txtScroll,
      leftBar1,
      rightBar1,
      rightBar2,
      countTo,
      centerLine,
      footer1
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/font/DS-DIGIT.TTF");
}
.container{
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/zhibo/bg.jpg") no-repeat top center;
  background-size: 100% 100%;
  position: relative;
  overflow: hidden;
  .title{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 95px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/zhibo/bt.png") no-repeat top center;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .return{
      width: 68px;
      height: 23px;
      cursor: pointer;
      margin-right: 50px;
      margin-top: 30px;
      position: relative;
      z-index: 999;
    }
    .return:first-child{
      margin-left: 50px;
    }
    .guang1{
      position: absolute;
      top: -32px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2{
      position: absolute;
      top: -32px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
       
  }
  
  
  .content{
    width: 100%;
    height:100vh;
    display: flex;
    .flexColumn{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .subTit{
      width: 100%;
      height: 45px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/zhibo/xbt.png") no-repeat 0 center;
      font-size: 20px;
      font-weight: bold;
      color: #fff;
      line-height: 45px;
      text-align: center;
      animation: subTit 2s linear infinite;
      position: relative;
    }
    .more{
        position: absolute;
        right: 90px;
        top: 50px;
        color: #00D7E1;
        font-size: 14px;
        font-weight: bold;
      }
      .more1{
         position: absolute;
        right: 100px;
        top: 192px;
        color: #00D7E1;
        font-size: 14px;
        font-weight: bold;
      }
    .leftContent1BTit{
        width: 100%;
        display: flex;
        height: 30px;
        justify-content: center;
        .leftContent1BItem{
          width: 70px;
          height: 30px;
          line-height: 26px;
          // box-shadow:0 0 10px 0 #047A72 inset;  
          border: 2px solid rgba(4, 122, 144, 0);   
          color: #fff;
          font-size: 14px;
          margin: 0 10px;
          transition: all 0.5s ease-out;
          cursor: pointer;
        }
        .leftContent1BItem:hover,.leftContent1BItemCur{
          border: 2px solid rgba(4, 122, 144, 1);
          border-radius: 15px;
          box-shadow: 0 0 20px rgb(4,122,114) inset,0 0 16px rgb(4,122,114);  
        }
      }
    .left,.right{
      width: 539px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .bg{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    .left{
      .bg{
        transform: rotate(180deg);
      }
      .leftBox{
        position: absolute;
        left: 0;
        top: 95px;
        width: 100%;
        height: calc(100% - 95px);
        .leftContent{
          width: 100%;
          flex: 1;
        }
        .leftBox1,.leftBox2{
          width: 100%;
        }
        // 左一
        .leftBox1{ 
          .leftContent1{
            display: flex;
            flex-direction: column;
            .leftContent1A{
              display: flex;
              width: 84%;
              height: 121px;
              .leftContent1Item{
                flex: 1;
              }
            }
            .leftContent1B{
              flex: 1;
              width: 85%;
              margin-left: 5%;
              margin-top: 20px;
              .leftContent1BContent{
                  width: 100%;
                  // flex: 1;
                  height: 120px;
              }
            }
          }
        }
        // 左二
        .leftBox2{
          height: 35%;
          .leftContent2{
            width: 80%;
            flex: 1;
            overflow: hidden;
            .leftContent2Tit{
              width: 100%;
              display: flex;
              justify-content: space-between;
              margin-top: 16px;
              span{
                display: block;
                font-size: 16px;
                background: linear-gradient(45deg, #03BBFF, #4DF5B0);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-weight: bold;
              }
              img{
                width: 257px;
                height: 13px;
                margin-top: 3px;
              }
            }
            .leftContent2Box{
              width: 100%;
              flex: 1;
              .tabTr{
                width: 100%;
                height: 30px;
                display: flex;
                padding: 0 10px;
                span{
                  display: block;
                  width: 30%;
                  font-size: 14px;
                  color: #fff;
                  line-height: 30px;
                  text-align: center;
                }
                span:nth-child(1){
                  width: 10%;
                } 
              }
              .leftContent2Info{
                width: 100%;
                flex: 1;
                overflow: hidden;
              }
              .scroll_item{
                width: 100%;
                height: 30px;
                font-size: 14px;
                display: flex;
                span{
                  display: block;
                  width: 30%;
                  font-size: 14px;
                  color: #fff;
                  line-height: 36px;
                  text-align: center;
                }
                span:nth-child(1){
                  width: 10%;
                  color: #F0BD26;
                } 
                span:nth-child(2),span:nth-child(3){
                  color: #00D7E1;
                }
                span:nth-child(4){
                  color: #4DF5B0;
                }
              }
            }
          }
        }
        // 左三
        .leftBox3{
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          position: relative;
          .leftContent3{
            position: absolute;
            top: 0;
            left: 5%;
            width: 80%;
            height: 100%;
            // border: 1px solid;
          }
        }
      }
    }
    .center{
      flex: 1;
      margin: 0 20px;
      position: relative;
      .centerBox{
        position: absolute;
        left: 0;
        top:110px;
        width: 100%;
        height: calc(100% - 95px);
        .center1{
          width: 100%;
          height: 137px;
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/zhibo/gdsz.png") no-repeat 0 center;
          background-size: 100% 100%!important;
          .numBox{
            position: absolute;
            left: 5%;
            top: 25px;
            width: 90%;
            height: 93px;
            line-height: 93px;
            font-size: 36px;
            color: #fff;
            letter-spacing: 10px;
            opacity: .8;
          }
        }
        .center2{
          width: 794px;
          height: 35px;
          margin: 0 auto;
        }
        .center3{
          width: 721px;
          height: 405px;
          background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/zhibo/sp.png") no-repeat;
          background-size: 100% 100%!important;
          padding:0 16px 16px;
          box-sizing: border-box;
          margin: 0 auto;
          img{
            width: 100%;
            height: 100%;
          }
          .videoBox{
            width: 100%;
            height: 100%;
          }
        }
        .center4{
          width: 100%;
          flex: 1;
          h3{
            width: 90%;
            font-size: 20px;
            font-weight: bold;
            color: #fff;
            text-align: left;
            margin-left: 5%;
            margin-top: 10px;
          }
          .centerContent4{
            width: 100%;
            flex: 1;
          }
        }
      }

    }
    .right{
      .rightBox{
        position: absolute;
        left: 0;
        top: 95px;
        width: 100%;
        height: calc(100% - 95px);
        .rightBox1{
          width: 100%;
          height: 150px;
          .rightContent1{
            width: 80%;
            flex: 1;
            margin-left: 12%;
          }
        }
        .rightBox2{
          width: 78%;
          height: 20%;
          margin-left: 10%;
          .rightTit{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin: 10px 0;
            span{
                display: block;
                font-size: 16px;
                background: linear-gradient(45deg, #03BBFF, #4DF5B0);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                font-weight: bold;
              }
              img{
                width: 257px;
                height: 13px;
                margin-top: 3px;
              }
          }
          .rightContent2{
            width: 100%;
            flex: 1;
            overflow: hidden;
            .scroll_item{
              width: 100%;
                height: 30px;
                font-size: 14px;
                display: flex;
                justify-content: space-between;
              span{
                display: block;
                width: 30%;
                font-size: 16px;
                color: #fff;
                line-height: 30px;
                text-align: center;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              span:nth-child(1){
                width: 10%;
                color: #00FFC3;
                text-align: left;
              }
              span:nth-child(2){
                width: 65%;
                color: #00D7E1;
                text-align: left;
              }
              span:nth-child(3){
                width: 20%;
                color: #1DC2FF;
                text-align: right;
              }
            }
            
          }
        }
        .rightBox3{
          width: 100%;
          flex: 1;
          .rightContent3{
            width: 100%;
            flex: 1;
            .rightEchart3{
              width: 100%;
              flex: 1;
            }
          }
        }
        .rightBox4{
          .rightContent2{
            .scroll_item{
              span:nth-child(1){
              color: #F0BD26;
            }
            }
            
          }
        }
        
      }
    }
    
  }
}
@keyframes titleGuang1{
  0%{
    left: 0;
  }
  100%{
    left: 15%;
  }
}
@keyframes titleGuang2{
  0%{
    right: 0;
  }
  100%{
    right: 15%;
  }
}
@keyframes subTit{
  0%{
    transform:  rotate(0deg);
    opacity: 1;
  }
  25%{
    transform:  rotate(1deg);
    opacity: .8;
  }
  50%{
    transform:  rotate(0deg);
  }
  100%{
    transform:  rotate(-1deg);
    opacity: .8;
  }
}




@keyframes line{
  0%{                     
      width: 0;
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    width: 96%;
  }
   100%{
     width: 0;
  }
} 
@keyframes bianda {
  0%{                     
       filter: drop-shadow(0 0 0 rgba(35, 151, 157, 1));
  } 
  50%{
     filter: drop-shadow(0 0 5px rgba(35, 151, 157, 1));
  }
   100%{
     filter: drop-shadow(0 0 0 rgba(35, 151, 157, 1));
  }
}
@keyframes daxiao {
  0%{                     
       transform: scale(0.96);
  } 
  50%{
    transform: scale(1);
  }
   100%{
    transform: scale(0.96);
  }
}
/* 定义关键帧 */
@keyframes guangying {    /*引用动画名称*/
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(360deg);
  }
}
@keyframes rightDaxiao {    /*引用动画名称*/
  0%{                     
       transform: scale(0.96);
       transform: rotate(0);
  } 
  50%{
    transform: scale(1.1);
    transform: rotate(20deg);
  }
   100%{
    transform: scale(0.96);
    transform: rotate(0deg);
  }
}
@keyframes rightDaxiao1 {    /*引用动画名称*/
  0%{                     
       width: 0;
  } 
  50%{
    width: 70%;
  }
   100%{
    width: 0;
  }
}

</style>
